import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import AdminScorecardActions from 'actions/scorecards/AdminScorecardActions';
import ScorecardActions from 'actions/scorecards/ScorecardActions';
import {List, Map, Record} from 'immutable';

@immutableStore
class ScorecardStore {
  constructor() {
    this.state = Record({
      scorecards: List(), // TODO remove me. this is too generic
      // oneoff questions loaded by id. used in the rare cases we are very interested
      // in a specific question rather than the card. see SubmittedReviewFileUpload
      scorecardQuestions: Map(), // Map<QuestionId, Question>
      scorecardsMap: Map(), // Map<ScorecardId, Scorecard>
      wasErrorFetching: false,
      areScorecardsFetching: false,
    })();
    this.bindActions(AdminScorecardActions);
    this.bindActions(ScorecardActions);
  }

  fetchAllScorecards() {
    this.setState({
      scorecards: List(),
      areScorecardsFetching: true,
      wasErrorFetching: false,
    });
  }

  fetchAllScorecardsSuccess(scorecards) {
    this.setState({areScorecardsFetching: false, scorecards});
  }

  fetchAllScorecardsError() {
    this.setState({areScorecardsFetching: false, wasErrorFetching: true});
  }

  fetchScorecardsForDepartment() {
    this.setState({
      scorecards: List(),
      areScorecardsFetching: true,
      wasErrorFetching: false,
    });
  }

  fetchScorecardsForDepartmentSuccess(scorecards) {
    this.setState({
      areScorecardsFetching: false,
      wasErrorFetching: false,
      scorecards,
    });
  }

  fetchScorecardsForDepartmentError() {
    this.setState({
      areScorecardsFetching: false,
      wasErrorFetching: true,
      scorecardsByEntityType: List(),
    });
  }

  fetchScorecard() {
    this.setState({
      areScorecardsFetching: true,
      wasErrorFetching: false,
    });
  }

  fetchScorecardSuccess(scorecard) {
    this.setState({
      scorecardsMap: this.state.scorecardsMap.set(scorecard.id, scorecard),
      areScorecardsFetching: false,
      wasErrorFetching: false,
    });
  }

  fetchScorecardError(scorecardId) {
    console.error('Error fetching scorecard:', scorecardId);
    this.setState({
      scorecardsMap: this.state.scorecardsMap.delete(scorecardId),
      areScorecardsFetching: false,
      wasErrorFetching: true,
    });
  }

  fetchScorecardQuestionById() {
    this.setState({
      areScorecardsFetching: true,
      wasErrorFetching: false,
    });
  }

  fetchScorecardQuestionByIdSuccess(question) {
    this.setState({
      scorecardQuestions: this.state.scorecardQuestions.set(question.id, question),
      areScorecardsFetching: false,
      wasErrorFetching: false,
    });
  }

  fetchScorecardQuestionByIdError(questionId) {
    this.setState({
      scorecardQuestions: this.state.scorecardQuestions.delete(questionId),
      areScorecardsFetching: false,
      wasErrorFetching: true,
    });
  }

  createScorecardSuccess(scorecard) {
    // This code is a hack. If a scorecard gets added, check
    // that a cloned one with the same name doesn't exist before
    // adding
    // Once this ticket gets finished, this can be fixed:
    // https://execvision.myjetbrains.com/youtrack/issue/EV-8413
    const {scorecards} = this.state;
    if (!scorecards.find(other => other.name === scorecard.name)) {
      this.setState({
        scorecards: scorecards.push(scorecard),
      });
    }
  }
}

export default alt.createStore(ScorecardStore);
